import { render, staticRenderFns } from "./pifaItem.vue?vue&type=template&id=c036d560&scoped=true&"
import script from "./pifaItem.vue?vue&type=script&lang=js&"
export * from "./pifaItem.vue?vue&type=script&lang=js&"
import style0 from "./pifaItem.vue?vue&type=style&index=0&id=c036d560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c036d560",
  null
  
)

export default component.exports